/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";
import styled from "styled-components/macro";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import _ from "lodash";
import {
  Timeline,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
} from "@mui/lab";

import {
  CardContent,
  Grid,
  Link,
  Breadcrumbs as MuiBreadcrumbs,
  Card as MuiCard,
  Divider as MuiDivider,
  Paper as MuiPaper,
  TextField,
  Typography,
  FormControl,
  Button,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Snackbar,
  Alert,
} from "@mui/material";
import { spacing } from "@mui/system";
import axios from "../../CustomAxios";
import Loading from "../components/Loading";
import moment from "moment";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const Card = styled(MuiCard)(spacing);

const Breadcrumbs = styled(MuiBreadcrumbs)(spacing);

const Paper = styled(MuiPaper)(spacing);

function FormDetails({
  apUsers,
  jobs,
  inOut,
  auditLogs,
  in_out_id,
  authData,
  onUpdateStatus,
}) {
  const [err, setErr] = useState("");
  const [rows, setRows] = useState([]);
  const [loader, setLoader] = useState(false);
  const snackRef = useRef(null);

  const [state, setState] = useState({
    open: false,
    vertical: "top",
    horizontal: "center",
  });
  const handleClick = (newState) => () => {
    setState({ open: true, ...newState });
  };
  const [approveOpen, setApproveOpen] = useState({ status: false, id: null });
  const [rejectOpen, setRejectOpen] = useState({ status: false, id: null });

  useEffect(() => {
    console.log(err);
  }, [err]);
  return (
    <>
      <Button
        ref={snackRef}
        style={{ display: "none" }}
        onClick={handleClick({ vertical: "top", horizontal: "center" })}
      >
        Click
      </Button>

      {!loader ? (
        <>
          <Card mb={6}>
            <CardContent>
              <Paper elevation={3} style={{ padding: "2%" }}>
                <Grid container spacing={5}>
                  <Grid item xs={12} lg={12} md={12}>
                    <Typography variant="h6" gutterBottom>
                      View Request
                    </Typography>
                  </Grid>

                  <Grid item xs={12} md={12} lg={12}>
                    <TextField
                      fullWidth
                      name="created_by"
                      value={inOut.created_by.name}
                      id="search-field"
                      label="Created By "
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={12}>
                    <TextField
                      fullWidth
                      name="plate"
                      value={inOut.plate.name}
                      id="search-field"
                      label="Plate "
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={12}>
                    <TextField
                      fullWidth
                      name="type"
                      value={_.capitalize(inOut.entry_type)}
                      id="search-field"
                      label="Type "
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={12}>
                    <TextField
                      fullWidth
                      name="ap_company"
                      value={inOut.ap_company.name}
                      id="search-field"
                      label="Ap Company "
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>

                  <Grid item xs={12} md={12} lg={12}>
                    <TextField
                      fullWidth
                      name="source_company"
                      value={inOut?.source_company?.name ? inOut.source_company.name : "Other"}
                      id="search-field"
                      label="Source Company "
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={12} lg={12}>
                    <TextField
                      fullWidth
                      type="number"
                      name="quantity"
                      multiline
                      value={inOut.quantity}
                      id="search-field"
                      label="Quantity"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={12} md={12}>
                    <TextField
                      fullWidth
                      name="remarks"
                      value={inOut.remarks}
                      label="Remarks"
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  {authData?.type === "super_admin" && (
                    <Grid item xs={3}>
                      <Button
                        variant="outlined"
                        sx={{ marginRight: "16px" }}
                        onClick={
                          () => {
                            setApproveOpen({
                              status: true,
                              id: inOut._id,
                            });
                          }
                          // onUpdateStatus(inOut._id, "approved")
                        }
                      >
                        Approve
                      </Button>
                      <Button
                        variant="outlined"
                        color="error"
                        onClick={
                          () => {
                            setRejectOpen({
                              status: true,
                              id: inOut._id,
                            });
                          }
                          // onUpdateStatus(row.id, "approved")
                        }
                      >
                        Decline
                      </Button>
                    </Grid>
                  )}
                </Grid>
              </Paper>
            </CardContent>
          </Card>

          <Card mb={6}>
            <CardContent>
              <Paper elevation={3} style={{ padding: "2%" }}>
                <Grid container spacing={5}>
                  <Grid item xs={12} md={12} lg={12}>
                    <Accordion>
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                      >
                        <Typography color="primary" variant="h6" gutterBottom>
                          Audit Logs
                        </Typography>
                      </AccordionSummary>
                      <AccordionDetails>
                        <Grid item xs={12} md={12} lg={12}></Grid>
                        <Timeline position="alternate">
                          {auditLogs &&
                            auditLogs?.map((audit, ind) => {
                              return ind % 2 === 0 ? (
                                <TimelineItem key={ind}>
                                  <TimelineOppositeContent
                                    align="right"
                                    variant="body2"
                                    color="secondary"
                                  >
                                    <br />
                                    {moment(
                                      audit?.audit_logs?.timestamp
                                    ).format("MMM DD, YYYY")}
                                    <br />
                                    {moment(
                                      audit?.audit_logs?.timestamp
                                    ).format(" hh:mm A")}
                                  </TimelineOppositeContent>
                                  <TimelineSeparator>
                                    <TimelineConnector />
                                    <TimelineDot
                                      color="primary"
                                      variant="outlined"
                                    ></TimelineDot>
                                    <TimelineConnector />
                                  </TimelineSeparator>
                                  <TimelineContent>
                                    <Typography variant="h6" component="span">
                                      {_.upperCase(audit?.audit_logs?.action)}
                                    </Typography>
                                    <Typography variant="body1">
                                      By-
                                      {audit?.audit_logs?.user_details?.name ||
                                        "Super Admin"}
                                    </Typography>
                                    <Typography variant="body2">
                                      {_.upperCase(
                                        audit?.audit_logs?.user_type
                                      ) || "SUPER ADMIN"}
                                    </Typography>
                                  </TimelineContent>
                                </TimelineItem>
                              ) : (
                                <TimelineItem key={ind}>
                                  <TimelineOppositeContent
                                    variant="body2"
                                    color="secondary"
                                  >
                                    <br />

                                    {moment(
                                      audit?.audit_logs?.timestamp
                                    ).format("MMM DD, YYYY")}
                                    <br />
                                    {moment(
                                      audit?.audit_logs?.timestamp
                                    ).format(" hh:mm A")}
                                  </TimelineOppositeContent>
                                  <TimelineSeparator>
                                    <TimelineConnector />
                                    <TimelineDot color="primary"></TimelineDot>
                                    <TimelineConnector />
                                  </TimelineSeparator>
                                  <TimelineContent>
                                    <Typography variant="h6" component="span">
                                      {_.upperCase(audit?.audit_logs?.action)}
                                    </Typography>
                                    <Typography variant="body1">
                                      By-{" "}
                                      {audit?.audit_logs?.user_details?.name ||
                                        "Super Admin"}
                                    </Typography>
                                    <Typography variant="body2">
                                      {_.upperCase(
                                        audit?.audit_logs?.user_type
                                      ) || "SUPER ADMIN"}
                                    </Typography>
                                  </TimelineContent>
                                </TimelineItem>
                              );
                            })}
                        </Timeline>
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                </Grid>
              </Paper>
            </CardContent>
          </Card>
          {/* Approve Dialog */}
          <Dialog
            open={approveOpen.status}
            onClose={() => setApproveOpen({ status: false, id: null })}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Are you sure, you want to Approve the  request?"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                It will effect the quantity in the inventory. You won't be able
                to revert this back
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                style={{ color: "#aaa" }}
                onClick={() => setApproveOpen({ status: false, id: null })}
              >
                Cancel
              </Button>
              <Button
                onClick={() => {
                  onUpdateStatus(approveOpen.id, "approved");
                  setApproveOpen({ status: false, id: null });
                }}
              >
                Approve
              </Button>
            </DialogActions>
          </Dialog>

          {/* rejecting Modal */}
          <Dialog
            open={rejectOpen.status}
            onClose={() => setRejectOpen({ status: false, id: null })}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              {"Are you sure, you want to Reject the request?"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                You will not be able to revert this back.
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setRejectOpen({ status: false, id: null })}
                style={{ color: "#aaa" }}
              >
                Cancel
              </Button>
              <Button
                color="error"
                onClick={() => {
                  onUpdateStatus(rejectOpen.id, "rejected");
                  setRejectOpen({ status: false, id: null });
                }}
              >
                Reject
              </Button>
            </DialogActions>
          </Dialog>
        </>
      ) : (
        <Loading />
      )}
    </>
  );
}

const getInOut = async (in_out_id, setInOut, setAuditLogs, setLoader) => {
  setLoader(true);
  try {
    const userData = JSON.parse(localStorage.getItem("AuthData"));
    const config = {
      headers: {
        Authorization: "Bearer " + userData.access_token,
      },
    };

    const inOut = await axios.get(
      `/api/v1/${userData?.type}/plate_inventory/inward_outward/plate_inventory/${in_out_id}`,
      config
    );
    if (inOut.data.success) {
      let result = inOut.data.data;
      let plate = result.plate;
      let plate_name = `${plate.height}X${plate.width}X${plate.thickness}${" "}
        || ${plate.brand.name} ||${" "}
        ${plate.technology.name}`;
      plate.name = plate_name;
      setInOut(result);
    }

    let auditLogsUrl = `/api/v1/${userData?.type}/plate_inventory/inward_outward/plate_inventory/${in_out_id}/audit_logs`;

    const auditLogsRes = await axios.get(auditLogsUrl, config);

    if (auditLogsRes.data.success) {
      setAuditLogs(auditLogsRes.data.data);
    }

    setLoader(false);
  } catch (e) {
    setLoader(false);
    console.log(e);
  }
};

function ViewInOut() {
  const [loader, setLoader] = useState(true);
  const [inOut, setInOut] = useState(null);
  const [auditLogs, setAuditLogs] = useState(null);
  const { in_out_id } = useParams();
  const snackRef = useRef(null);
  const [err, setErr] = useState("");
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getInOut(in_out_id, setInOut, setAuditLogs, setLoader);
  }, []);
  const authData = JSON.parse(localStorage.getItem("AuthData"));

  // Update status of plate
  const onUpdateStatus = async (id, status) => {
    setLoader(true);
    try {
      const authData = JSON.parse(localStorage.getItem("AuthData"));

      const config = {
        headers: {
          Authorization: "Bearer " + authData.access_token,
        },
      };
      let url = `/api/v1/${authData?.type}/plate_inventory/inward_outward`;

      const updated = await axios.put(
        url,
        {
          plate_inventory_id: id,
          status: status,
        },
        config
      );
      if (updated.data.success) {
        navigate("/dashboard/inventory/approval-in-out", {
          state: { success: true, message: "Request Created Successfully" },
        });
        // setSuccess(`Request ${status} successfully`);
        setLoader(false);

        // snackRef?.current?.click();
        // let params = {
        //   quantity: returnParam("quantity"),
        //   created_by: returnParam("created_by"),
        //   entry_type: returnParam("entry_type"),
        //   approved: returnParam("approved"),
        //   rejected: returnParam("rejected"),
        // };
        // getApUsers(selectedApCompany, setApUsers, setLoader);
        // getInwardOutward(params);
      }
    } catch (e) {
      setLoader(false);
      console.log(e);
      if (e.response && e.response.data && e.response.data.error) {
        setErr(e.response.data.error);
        setOpen(true);
      } else {
        setErr("Server Error");
        setOpen(true);
      }
      snackRef?.current?.click();
    }
  };

  if (!loader) {
    return (
      <React.Fragment>
        <Helmet title="Alpha Plus" />
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          // key={vertical + horizontal}
        >
          {err && (
            <Alert mt={2} mb={4} severity="error">
              {err}
            </Alert>
          )}
        </Snackbar>
        <Grid
          justifyContent="space-between"
          alignItems="center"
          container
          spacing={10}
          mb={4}
        >
          <Grid item>
            <Typography
              variant="h4"
              gutterBottom
              display="inline"
              sx={{ fontWeight: 600 }}
              color="primary"
            >
              VIEW IN-OUT
            </Typography>
          </Grid>
          <Grid item>
            <Breadcrumbs aria-label="Breadcrumb" mt={2}>
              <Link component={NavLink} to="/dashboard/tasks">
                Dashboard
              </Link>
              <Link component={NavLink} to="/dashboard/inventory">
                Inventory
              </Link>
              <Link component={NavLink} to="/dashboard/inventory/in-out">
                In-Out
              </Link>

              <Typography>{in_out_id}</Typography>
            </Breadcrumbs>
          </Grid>
        </Grid>

        <Grid container spacing={6}>
          <Grid item xs={12}>
            {inOut && (
              <FormDetails
                inOut={inOut}
                auditLogs={auditLogs}
                inOutId={in_out_id}
                authData={authData}
                onUpdateStatus={onUpdateStatus}
              />
            )}
          </Grid>
        </Grid>
      </React.Fragment>
    );
  } else {
    return <Loading />;
  }
}

export default ViewInOut;
